<alert [type]="type"  [dismissible]="dismissible" [dismissOnTimeout]="timeout">
  <i class="fa fa-lg {{alertIcon}} fa-fw"></i> {{alertMessage}} </alert>